// extracted by mini-css-extract-plugin
export default {"logo":"RequestedPage_logo__XWDsV","footerSpan":"RequestedPage_footerSpan__faDQE","link":"RequestedPage_link__3j6Be"};